<template>
  <tw-custom-dialog transition="fadet"
                    width="600"
                    v-model="dialog">

    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Cadastro empresa
    </template>
    <template>
      <v-row dense>
        <v-col cols="12" sm="12" md="12">
          <v-text-field outlined
                        hide-details
                        maxlength="255"
                        class="required"
                        label="Nome do Empresa"
                        :error="$v.empresaEdit.nome.$error"
                        @blur="$v.empresaEdit.nome.$touch()"
                        v-model="empresaEdit.nome"/>
        </v-col>
        <v-col cols="6" sm="6" md="6">
          <tw-time-picker
            input-class="required"
            v-model="empresaEdit.inicioAtendimento"
            label="Hora início"
          />
        </v-col>
        <v-col cols="6" sm="6" md="6">
          <tw-time-picker
            input-class="required"
            v-model="empresaEdit.fimAtendimento"
            label="Hora fim"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <br />
          <v-chip-group id="teste"
            multiple
            column
            active-class="primary--text"
            :value="this.empresaEdit.diasAtendimento"
            @change="novosDiasAtendimento => atualizaDiasAtendimento(novosDiasAtendimento)"
            class="centralizaDia">
            <v-chip v-for="dia in this.diasDaSemana" :key="dia" class="centralizaDia" :value="dia">
              {{ getLabelDiaSemana(dia) }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="mr-2"
             :loading="loadingForm"
             @click="save">
        Salvar
      </v-btn>
      <v-btn @click="close">Cancelar</v-btn>
    </template>

  </tw-custom-dialog>
</template>

<script>
import EmpresaService from '@/api/empresas-service';
import { required } from 'vuelidate/lib/validators';
import dayOfWeek from '@/enums/day-of-week';
import _ from 'lodash';

function resetEdit() {
  return {
    id: null,
    nome: null,
    inicioAtendimento: null,
    fimAtendimento: null,
  };
}

export default {
  props: {
    empresa: Object,
  },
  data() {
    return {
      empresaEdit: resetEdit(),
      dialog: false,
      loadingForm: false,
      diasDaSemanaSelecionados: [],
      diasDaSemana: Object.keys(dayOfWeek.keys),
    };
  },
  watch: {
    dialog() {
      if (this.empresa) {
        this.empresaEdit = _.cloneDeep(this.empresa);
      } else {
        this.empresaEdit = resetEdit();
      }
      this.$v.$reset();
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      this.loadingForm = true;
      EmpresaService.save(this.empresaEdit)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Empresa salva', { color: 'success' });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    getLabelDiaSemana(dia) {
      return dayOfWeek.keys[dia].description;
    },
    atualizaDiasAtendimento(novosDiasAtendimento) {
      this.empresaEdit.diasAtendimento = novosDiasAtendimento;
    },
  },
  validations: {
    empresaEdit: {
      nome: {
        required,
      },
      inicioAtendimento: {
        required,
      },
      fimAtendimento: {
        required,
      },
      telefone: {
        required,
      },
    },
  },
};
</script>

<style scoped>
.centralizaDia {
justify-content: center;
}
</style>

<style>
.v-slide-group__content {
justify-content: center;
}
</style>
